import styled from '@emotion/styled';

const SectionContainer = styled.div<{ isFirstChild?: boolean }>`
  display: grid;
  grid-auto-flow: row dense;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  column-gap: 1rem;

  :not(:last-child) {
    margin-bottom: 4rem;
  }

  ${({ isFirstChild, theme }) =>
    !isFirstChild && `margin-top: ${theme.spacing[70]};`}

  ${({ theme }) => theme.mq('sm')} {
    :not(:last-child) {
      margin-bottom: ${({ theme }) => theme.spacing[10]};
    }
  }

  ${({ theme }) => theme.mq('lg')} {
    column-gap: ${({ theme }) => theme.spacing[50]};
  }
`;

export { SectionContainer };
